import { render, staticRenderFns } from "./TaskItem.vue?vue&type=template&id=4add9e12&scoped=true"
import script from "./TaskItem.vue?vue&type=script&lang=js"
export * from "./TaskItem.vue?vue&type=script&lang=js"
import style0 from "./TaskItem.vue?vue&type=style&index=0&id=4add9e12&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4add9e12",
  null
  
)

export default component.exports